/**
 * Input Group
 * 
 * The input group component is used for grouping multiple input elements together.
 * It provides a flexible layout for arranging inputs in two columns or
 * a single column for sm devices, unless forcedColumns is set to true.
 */

interface InputGroupProps {
    children?: React.ReactNode,
    className?: string,
    forcedColumns?: boolean,
    key?: string
}

const InputGroup: React.FC<InputGroupProps> = ({ children, className, forcedColumns = false, key }) => {
    return (
        <div
            className={`grid ${forcedColumns ? 'grid-cols-2' : 'sm:grid-cols-2'} gap-x-4 gap-y-4 items-start w-fit ${className ? className : ''}`}
            key={key}
        >
            {children}
        </div>
    )
}

export default InputGroup

